import { CanDeactivateFn } from '@angular/router';
import { SurveyFormEditorComponent } from './survey-form-editor.component';

export const surveyFormEditorCanDeactivate: CanDeactivateFn<SurveyFormEditorComponent> = (
  component,
) => {
  if (!component?.isDirty) return true;
  return window.confirm(
    'Você tem alterações não salvas. Sair sem salvar?',
  );
};
